var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:{
    '-jobOffer': _vm.$route.name === 'job_offer',
    '-redesignedPage': _vm.isRedesignedPage,
    '-cookieOpened': !_vm.hidden,
  },attrs:{"id":"app"}},[_c('div',{staticClass:"blind-stopper",attrs:{"id":"vue-blind-stopper"}},[_c('img',{attrs:{"title":"Appjobs","alt":"Appjobs","width":"320","height":"588","src":_vm.blindStopperImageSrc}})]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }